<div class="current-station-type-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.current-station-type-editor.current-station-type"></sc-dictionary-label>
            </mat-label>
            <mat-select formControlName="stationType" name="stationType">

                <ng-container *ngFor="let type of stationTypes">
                    <mat-option [value]="type">
                      <sc-dictionary-label dictionaryKey="tmc-yard.common.enum.station-type.{{type}}"></sc-dictionary-label>
                    </mat-option>
                </ng-container>

            </mat-select>
        </mat-form-field>
    </div>
</div>
